/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deck_Validation_UnavailableInputs */



/**
* | output |
* | --- |
* | "Couldn't check this deck's legality yet — card data is still loading." |
*
* @param {Deck_Validation_UnavailableInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deck_validation_unavailable = /** @type {((inputs?: Deck_Validation_UnavailableInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deck_Validation_UnavailableInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de vérifier la légalité de ce deck pour le moment — les données des cartes sont encore en cours de chargement.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aún no se pudo comprobar la legalidad de este mazo — los datos de las cartas todavía se están cargando.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ainda não foi possível verificar a legalidade deste deck — os dados das cartas ainda estão carregando.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Non è stato ancora possibile verificare la legalità di questo mazzo — i dati delle carte sono ancora in fase di caricamento.")
	return /** @type {LocalizedString} */ ("Couldn't check this deck's legality yet — card data is still loading.")
});